import { supabase } from '../supabase';

// Todas as telas do Teste Jarvis falam com /api/jarvis?acao=... (conversas ficam trancadas
// no banco; só o servidor lê e grava).
let ultimoToken = '';

export async function jarvis(acao, dados = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  ultimoToken = session?.access_token || ultimoToken;
  const r = await fetch(`/api/jarvis?acao=${encodeURIComponent(acao)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session?.access_token || ''}` },
    body: JSON.stringify(dados),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Erro ${r.status}`);
  return j;
}

// Para quando a página está fechando (não dá para esperar a sessão): usa o último token
// e keepalive, que o navegador entrega mesmo depois de fechar a aba.
export function jarvisAoFechar(acao) {
  if (!ultimoToken) return;
  try {
    fetch(`/api/jarvis?acao=${encodeURIComponent(acao)}`, {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${ultimoToken}` }, body: '{}',
    }).catch(() => {});
  } catch { /* navegador sem keepalive */ }
}

// Duração legível: 45s · 12min 05s · 2h 10min
export function duracao(ms) {
  if (ms == null || !isFinite(ms) || ms < 0) return '—';
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}min ${String(s % 60).padStart(2, '0')}s`;
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}min`;
}

export const ESTADOS = {
  bot: { rotulo: 'No robô', cor: '#6b7280' },
  espera: { rotulo: 'Aguardando', cor: '#d97706' },
  atendimento: { rotulo: 'Em atendimento', cor: '#16a34a' },
  encerrada: { rotulo: 'Encerrada', cor: '#9ca3af' },
  grupo: { rotulo: 'Grupo', cor: '#2563eb' },
};

export function formatarTelefone(t) {
  const d = String(t || '').replace(/\D/g, '');
  const m = d.match(/^55(\d{2})(\d{4,5})(\d{4})$/);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : d;
}

export function hora(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const hoje = new Date();
  return d.toDateString() === hoje.toDateString()
    ? d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

export function tempoDesde(iso) {
  if (!iso) return '';
  const min = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  return h < 24 ? `${h}h${String(min % 60).padStart(2, '0')}` : `${Math.floor(h / 24)}d`;
}
